import React from "react";
import { useOutletContext } from "react-router";

const Info = ({ categories, active, setActive }) => {
  const { homepageInfo } = useOutletContext();

  return (
    <div className="info">
      <ul className="category">
        {categories.map((ele, idx) => (
          <li
            key={idx}
            className={ele.categoryId === active?.categoryId ? "active" : "inactive"}
            onClick={() => setActive(ele)}>
            {ele.categoryName}
          </li>
        ))}
      </ul>
      <span>{homepageInfo?.cmpnyNm}</span>
      <strong>{active?.categoryName}</strong>
      <p>{active?.description}</p>
    </div>
  );
};

export default Info;
